













// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/flux/edit/EditPartenaires.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'

@Component({
  name: 'ReadPartenaires',    
  components:{Edit},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    flux:{
      type:Object,
      default:getDefaultAloFlux()
    },
    editable:{
      type:Boolean,
      default:true      
    }
  }
})
export default class ReadPartenaires extends Vue {
  
  private flux!:AloFlux
  private loading!:boolean

  get partenaire(){
    return this.$store.myGetters.partenaire
  } 

  edit() { (this.$refs.edit as Edit).edit(this.flux) }

}
